<script>
    import { changeAantal } from '../store.js';

    export let name
    export let aantal
    let multipleVal = 1;
    let input;

    function add(e) {
        // add 1 to input value
        let newValue = parseInt(input.value) + 1;
        newValue = checkMinMax(newValue);
        if (newValue !== null) {
            changeVal(newValue)
        }
    }

    function subtract(e) {
        // subtract 1 from input value
        let newValue = parseInt(input.value) - 1;
        newValue = checkMinMax(newValue);
        if (newValue !== null) {
            changeVal(newValue)
        }
    }

    function changeVal(val) {
        input.value = val
        multipleVal = val
        changeAantal(name, val)
    }

    function checkMinMax(newValue) {

        let val;
        if(isNaN(newValue)) {
            val = parseInt(newValue.target.value)
        } else {
            val = parseInt(newValue)
        }
        let min = parseInt(input.getAttribute('min'));
        let max = parseInt(input.getAttribute('max'));
        if (val < 1) {
            changeVal(min)
            return min;
        } else if (val > 9) {
            changeVal(max)
            return max;
        } else {
            changeVal(val)
            return val;
        }
    }

    function preventTyping(e) {
        const keycodes = { 
            107: 'plus',
            61: 'equals',
            187: 'equals',
            109: 'minus',
            189: 'minus',
            111: 'slash',
            191: 'slash',
            106: 'asterisk',
            56: 'asterisk',
            69: 'e'
        };
        const keycode = e.keyCode;
        if (keycode in keycodes) {
            e.preventDefault();
            return;
        }
    }

</script>

<label for='{name}-aantal' class="label-number">
    <span>Aantal <span style="text-transform:lowercase">{name}s</span></span>
    <div>
        <div class="subtract" on:click={subtract}>-</div>
        <input on:keydown={preventTyping} on:input={checkMinMax} bind:this={input} type="number" value={multipleVal} name='{name}-aantal' id='{name}-aantal' min="1" max="9">
        <div class="add" on:click={add}>+</div>
    </div>
</label>


<style>
    label {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        background: white;
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23003F31FF' stroke-width='3' stroke-dasharray='6%2c 14' stroke-dashoffset='11' stroke-linecap='square'/%3e%3c/svg%3e");
        border: 0;
        transition: all .3s ease-in;
        border-radius: 8px;
        margin-bottom: 10px;
    }
    label span {
        font-size: 16px;
        font-weight: 700;
        font-family: 'Poppins',Helvetica,Arial,Lucida,sans-serif;
        color: #003f31;
    }

    input {
        all: unset;
        background: rgba(0,63,49,.1);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        text-align: center;
        border-radius: 5px;
    }

    .add, .subtract {
        cursor: pointer;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input {
        font-size: 16px;
        font-weight: 700;
    }

    label > div {
        display: flex;
        gap: 10px;
        justify-content: center;
        align-items: center;
    }
    label div div {
        font-size: 24px;
        color: #CA1E22;
    }

</style>